import { render, staticRenderFns } from "./AuthCode.vue?vue&type=template&id=6f62ca34&scoped=true&"
import script from "./AuthCode.vue?vue&type=script&lang=js&"
export * from "./AuthCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62ca34",
  null
  
)

export default component.exports